import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuStateService {
  //sidenavState$: BehaviorSubject<{ opened: boolean, condensed: boolean }>;
  sidenavState$: BehaviorSubject<{ opened: boolean}>;
  themeState$: BehaviorSubject<'ams-content-light' | 'ams-content-dark'>;

  constructor() {
    this.sidenavState$ = new BehaviorSubject<{ opened: boolean /*, condensed: boolean*/ }>({ opened: false, /*condensed: false*/ });
  
    const savedTheme = localStorage.getItem('theme') || 'ams-content-light';  // Load from local storage if available
    this.themeState$ = new BehaviorSubject<'ams-content-light' | 'ams-content-dark'>(savedTheme as 'ams-content-light' | 'ams-content-dark');
    this.applyTheme(savedTheme);
  }

  toggleSidenav() {
    const currentState = this.sidenavState$.getValue();

    // if (currentState.opened && currentState.condensed) {
    //   // From condensed to closed
    //   this.sidenavState$.next({ opened: false, condensed: false });
    // } else if (currentState.opened && !currentState.condensed) {
    //   // From opened to condensed
    //   this.sidenavState$.next({ opened: true, condensed: true });
    // } else {
    //   // From closed to opened
    //   this.sidenavState$.next({ opened: true, condensed: false });
    // }

    // From opened to closed
    if (currentState.opened){
      this.sidenavState$.next({ opened: false});
    }
    // From closed to opened
    else{
      this.sidenavState$.next({ opened: true });
    }
  }

  toggleTheme(){
    console.log(`current theme is ${this.themeState$.getValue()}`);
    const currentTheme = this.themeState$.getValue();
    const newTheme = currentTheme === 'ams-content-light' ? 'ams-content-dark' : 'ams-content-light';
    console.log(`changing to ${newTheme}`);
    this.themeState$.next(newTheme);
    localStorage.setItem('theme', newTheme);
    this.applyTheme(newTheme);
  }

  applyTheme(theme: string){
    console.log('Checking for .ams-content in DOM:', document.querySelector('.ams-content'));
    console.log('applying theme...')
    const themeContainer = document.querySelector('.ams-content');
    if (themeContainer){
      themeContainer.classList.remove('ams-content-light', 'ams-content-dark');
      themeContainer.classList.add(theme);
    }
    else{
      console.log('no theme container found!');
    }
  }
}